import { COLOR } from "../../common/Color"


export class ColorUtils {

    static colorHexStringToNumber = (hexString: string) => parseInt(hexString.replace(/^#/, ""), 16)

    static setBackgroundColorBlack = (game: Phaser.Game) => {
        ColorUtils.setBackgroundColor(game, COLOR.black)
    }

    static setBackgroundColorGray = (game: Phaser.Game) => {
        ColorUtils.setBackgroundColor(game, COLOR.gray)
    }

    static setBackgroundColorLightGray = (game: Phaser.Game) => {
        ColorUtils.setBackgroundColor(game, COLOR.lightGray)
    }

    static setGameBackgroundColorGreen = (game: Phaser.Game) => {
        game.stage.backgroundColor = COLOR.backgroundGreen
    }

    static setBackgroundColor = (game: Phaser.Game, color: string) => {
        game.stage.backgroundColor = color
        document.body.style.backgroundColor = color
    }

    static setGameBackgroundColor = (game: Phaser.Game, color: string) => game.stage.backgroundColor = color

    static setPageBackgroundColor = (color: string) => document.body.style.backgroundColor = color

    /**
     * This is inspired by:
     *
     * https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
     *
     */
    /* tslint:disable */
    static shadeColor = (color: string, percent: number): number => {
        const f = parseInt(color.slice(1), 16), t = percent < 0 ? 0 : 255, p = percent < 0 ? percent * -1 : percent,
            R = f >> 16, G = f >> 8 & 0x00FF, B = f & 0x0000FF
        return (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100
            + (Math.round((t - B) * p) + B))
    }
    /* tslint:enable */

    /**
     * @param {Phaser.Sprite | Phaser.Button} toShade
     * @param {Phaser.Timer} timer
     * @param {number} loopDelay
     * @param {string} shadeColor
     * @param {number} shadeToPercent -- Number between 0.0 and 0.93. The lower the darker the shade will get.
     */
    static shadeInALoop = (
        toShade: Phaser.Sprite | Phaser.Button, timer: Phaser.Timer, loopDelay: number,
        shadeColor: string, shadeToPercent: number
    ) => {
        let currentShadePercent = 0.94
        const shadeLoop = timer.loop(loopDelay, () => {
            if (currentShadePercent > shadeToPercent) {
                const currentTint = ColorUtils.shadeColor(shadeColor, currentShadePercent)
                currentShadePercent -= 0.02
                toShade.tint = currentTint
            } else {
                timer.remove(shadeLoop)
            }
        })
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const colorNum = {} as any
for (const colorString in COLOR) {
    colorNum[colorString] = ColorUtils.colorHexStringToNumber(COLOR[colorString])
}
/* tslint:enable */
